import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { solutionSteps } from '../../data/content';
export function SolutionSection() {
  const lastIndex = solutionSteps.length - 1;
  return <section id="solution" className="bg-white px-5 py-14 sm:py-20" data-id="element-109" data-mp="1jp63xsoyms2r">
      <div className="mx-auto max-w-5xl" data-id="element-110" data-mp="1jnv0xv3c9ocp">
        <SectionHeading title="What If Every Reading Already Had a Clear Roadmap?" data-id="element-111" data-mp="1ohg37zbyt4hp" />

        <ol className="mx-auto mt-10 grid max-w-md gap-3 sm:max-w-none sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-112" data-mp="1tg0tb5xi67sf">
          {solutionSteps.map((step, index) => {
          const isLast = index === lastIndex;
          return <li key={step} className={`flex items-center gap-4 rounded-2xl border px-5 py-4 ${isLast ? 'border-brand-violet bg-brand-violet text-white' : 'border-brand-violet/15 bg-brand-mist text-brand-ink'}`} data-id="element-113" data-mp="23e6rbcg6uts0" data-mpi={index}>
                <span className={`flex h-9 w-9 flex-none items-center justify-center rounded-full font-display text-base font-bold ${isLast ? 'bg-white text-brand-violet' : 'bg-brand-violet text-white'}`} data-id="element-114" data-mp="d0pry1sopmh8">
                  {index + 1}
                </span>
                <span className="text-sm font-black uppercase tracking-wide" data-id="element-115" data-mp="3rz1crht4m3in">{step}</span>
              </li>;
        })}
        </ol>

        <div className="mx-auto mt-10 max-w-2xl space-y-4 text-center text-base leading-relaxed text-brand-ink/75 sm:text-lg" data-id="element-116" data-mp="3i3pvosu8wk7q">
          <p data-id="element-117" data-mp="jksqerh768yx">Astrologer Ready turns your existing astrology knowledge into a repeatable professional workflow.</p>
          <p data-id="element-118" data-mp="emzi9swc34w0">
            Instead of wondering where to begin, you'll have frameworks, checklists, interpretation systems, scripts, dashboards and client-ready tools guiding you from preparation to final delivery.
          </p>
        </div>

        <p className="mx-auto mt-8 max-w-3xl text-center font-display text-2xl font-bold leading-snug text-brand-ink sm:text-3xl" data-id="element-119" data-mp="2udvjmdhr2zoj">
          Less searching. Less guessing. Less improvising.{' '}
          <span className="text-brand-violet" data-id="element-120" data-mp="1hf3hxz39f8le">More structure.</span>
        </p>

      </div>
    </section>;
}